import Header from '../components/Header';
import Footer from '../components/Footer';
import { contactRGPD } from './Mandat';

function PolitiqueConfidentialite() {

  const resetCookieChoice = () => {
    localStorage.removeItem('cookieConsent');
    window.location.reload();
  };
  return (
    <div className="flex flex-col min-h-screen dark:bg-fond-sombre">
      <Header/>

      <main className="flex-grow max-w-4xl mx-auto p-6 space-y-6 mb-16">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gris-sombre dark:text-blanc-sombre text-center mt-12">Politique de confidentialité</h1>
        <p className="text-1xl font-bold text-gray-800 dark:text-blanc-sombre text-center">Dernière mise à jour : 22 octobre 2026</p>
        <br/>
        <p className="dark:text-blanc-sombre">Notre Junior-Entreprise Ingénierie et Conseil en Cognitique (i2c) s’engage à protéger la vie privée des utilisateurs de son site Internet. Cette politique
          de confidentialité explique comment nous utilisons et protégeons vos données personnelles.</p>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Responsable du traitement des données</h2>
          <p className="dark:text-blanc-sombre">
            Raison sociale : Ingénierie et Conseil en Cognitique<br/>
            Siège social : 109 Avenue Roul, 33400 Talence<br/>
            E-mail : <a href={`mailto:${contactRGPD.mail}`} className="text-blue-600 underline">{contactRGPD.mail}</a><br/>
            <br/>
            Le responsable du traitement des données est chargé de veiller au respect de la réglementation applicable sur les
            données personnelles.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Données personnelles collectées</h2>
          <p className="dark:text-blanc-sombre">
            Lorsque vous remplissez notre formulaire de contact, nous collectons les informations suivantes :<br/>
            <br/>
            • Nom et prénom<br/>
            • Numéro de téléphone<br/>
            • Adresse e-mail<br/>
            • Nom du projet et contenu du message<br/>
            <br/>
            Aucune autre donnée n’est collectée sans votre consentement explicite.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Finalités de la collecte</h2>
          <p className="dark:text-blanc-sombre">
            Les données recueillies sont utilisées uniquement pour :<br/>
            <br/>
            • Répondre à vos demandes via le formulaire de contact<br/>
            • Vous fournir les informations ou services que vous avez sollicités<br/>
            • Analyser l'audience du site et mesurer sa fréquentation via Google Analytics (afin d'en améliorer l'ergonomie et le contenu)<br/>
            • Assurer la sécurité et le bon fonctionnement du site
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Base légale du traitement</h2>
          <p className="dark:text-blanc-sombre">
            Le traitement de vos données personnelles repose sur :<br/>
            • Votre <strong>consentement</strong> lors de l’envoi du formulaire de contact.<br/>
            • Votre <strong>consentement préalable</strong> exprimé via le bandeau cookies pour la mesure d'audience Google Analytics.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Durée de conservation des données</h2>
          <p className="dark:text-blanc-sombre">
           • <strong>Formulaire de contact :</strong> 3 ans maximum à compter du dernier contact.<br/>
           • <strong>Données de mesure d'audience (Google Analytics) :</strong> 14 mois maximum.<br/>
           • <strong>Choix sur le dépôt de cookies :</strong> 6 mois (mémorisé dans votre navigateur)..</p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Partage et transfert des données</h2>
          <p className="dark:text-blanc-sombre">
            Vos données ne sont ni vendues, ni louées ni échangées à des tiers.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Sécurité des données</h2>
          <p className="dark:text-blanc-sombre">
            Nous mettons en place des mesures techniques et organisationnelles appropriées pour protéger vos données contre
            la perte, l’accès non autorisé, la divulgation ou toute autre forme de traitement illégal.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Vos droits</h2>
          <p className="dark:text-blanc-sombre">
            Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :<br/>
            <br/>
            • Droit d’accès : demander des informations sur les données traitées<br/>
            • Droit à la portabilité : récupérer vos données personnelles dans un format utilisable<br/>
            • Droit d’effacement : demander la suppression de vos données (dans certains cas précis)<br/>
            • Droit de rectification : corriger des informations inexactes ou incomplètes vous concernant<br/>
            • Droit d’opposition : s’opposer à un traitement (dans certains cas précis)<br/>
            <br/>
            Pour exercer vos droits, contactez-nous à l’adresse e-mail : <a href={`mailto:${contactRGPD.mail}`} className="text-blue-600 underline">{contactRGPD.mail}</a>
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Cookies</h2>
          <p className="dark:text-blanc-sombre">
           Ce site utilise un cookie technique pour mémoriser votre préférence d'affichage (mode clair/sombre) ainsi que des cookies de mesure d'audience Google Analytics.<br/><br/>
            Vous pouvez modifier votre choix concernant les cookies analytiques à tout moment en cliquant sur le bouton ci-dessous :
          </p>
          <button
            onClick={resetCookieChoice}
            className="px-4 py-2 bg-bleu-footer hover:bg-bleu-je text-gris-clair rounded-md text-sm font-medium transition"
          >
            Modifier mes préférences de cookies
          </button>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-bleu-gris">Modifications de la politique de confidentialité</h2>
          <p className="dark:text-blanc-sombre">
            Cette politique peut être mise à jour périodiquement. La dernière version est toujours disponible sur notre site.
          </p>
        </section>
      </main>

      <Footer/>
    </div>
  );
}

export default PolitiqueConfidentialite;